import apiService from './apiService';
import { API_ENDPOINTS } from '../config/api';

class MessageService {
  async getMessages(page = 1, limit = 15, params = {}) { // MÓDOSÍTVA: paraméterek hozzáadva
    try {
      const queryString = new URLSearchParams({ page, limit, ...params }).toString();
      const response = await apiService.get(`${API_ENDPOINTS.MESSAGES.LIST}?${queryString}`);
      return response;
    } catch (error) {
      console.error('Error fetching messages:', error);
      throw error;
    }
  }

  async getUnreadMessageCount() { // ÚJ METÓDUS
    try {
      const response = await apiService.get(API_ENDPOINTS.MESSAGES.UNREAD_COUNT);
      return response;
    } catch (error) {
      console.error('Error fetching unread message count:', error);
      throw error;
    }
  }

  async getConversation(participantId) { // ÚJ METÓDUS
    try {
      const response = await apiService.get(API_ENDPOINTS.MESSAGES.CONVERSATION(participantId));
      return response;
    } catch (error) {
      console.error('Error fetching conversation:', error);
      throw error;
    }
  }

  async sendMessage(recipientId, content) {
    try {
      const response = await apiService.post(API_ENDPOINTS.MESSAGES.SEND, { recipientId, content });
      return response;
    } catch (error) {
      console.error('Error sending message:', error);
      throw error;
    }
  }

  async markMessageAsRead(messageId) {
    try {
      const response = await apiService.put(API_ENDPOINTS.MESSAGES.MARK_READ(messageId));
      return response;
    } catch (error) {
      console.error('Error marking message as read:', error);
      throw error;
    }
  }

  // ÚJ: markMessageAsUnread (ha a backend támogatja)
  async markMessageAsUnread(messageId) {
    try {
      // Feltételezve, hogy a backendben van PUT /api/messages/:id/unread végpont
      const response = await apiService.put(API_ENDPOINTS.MESSAGES.MARK_UNREAD(messageId));
      return response;
    } catch (error) {
      console.error('Error marking message as unread:', error);
      throw error;
    }
  }

  // ÚJ: deleteMessage (ha a backend támogatja)
  async deleteMessage(messageId) {
    try {
      // Feltételezve, hogy a backendben van DELETE /api/messages/:id végpont
      const response = await apiService.delete(API_ENDPOINTS.MESSAGES.DELETE(messageId));
      return response;
    } catch (error) {
      console.error('Error deleting message:', error);
      throw error;
    }
  }

  // ÚJ: markMultipleAsRead (ha a backend támogatja)
  async markMultipleAsRead(messageIds) {
    try {
      // Feltételezve, hogy a backendben van PUT /api/messages/read-multiple végpont
      const response = await apiService.put(API_ENDPOINTS.MESSAGES.MARK_MULTIPLE_READ, { messageIds });
      return response;
    } catch (error) {
      console.error('Error marking multiple messages as read:', error);
      throw error;
    }
  }

  // ÚJ: markMultipleAsUnread (ha a backend támogatja)
  async markMultipleAsUnread(messageIds) {
    try {
      // Feltételezve, hogy a backendben van PUT /api/messages/unread-multiple végpont
      const response = await apiService.put(API_ENDPOINTS.MESSAGES.MARK_MULTIPLE_UNREAD, { messageIds });
      return response;
    } catch (error) {
      console.error('Error marking multiple messages as unread:', error);
      throw error;
    }
  }

  // ÚJ: deleteMultiple (ha a backend támogatja)
  async deleteMultiple(messageIds) {
    try {
      // Feltételezve, hogy a backendben van DELETE /api/messages/delete-multiple végpont
      const response = await apiService.delete(API_ENDPOINTS.MESSAGES.DELETE_MULTIPLE, { data: { messageIds } }); // DELETE kérés body-val
      return response;
    } catch (error) {
      console.error('Error deleting multiple messages:', error);
      throw error;
    }
  }
}

export default new MessageService();